import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import './AZStore.scss'

class AZStore extends PureComponent {
  render () {
    return (
      <div className='az-store'>
        <span className='azs-text'>Can't find your store?</span>
        <a href='#storeslist' className='link azs-link' onClick={() => this.props.showAZList(true)}>Check our A-Z list</a>
      </div>
    )
  }
}

AZStore.propTypes = {
  showAZList: PropTypes.func
}

export default AZStore



// WEBPACK FOOTER //
// ./src/components/AZStore/AZStore.jsx